import React, { Component } from "react";
import DataNotFound from "../DataNotFound";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch() {
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return <DataNotFound text="Platform ran into issues" />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
